import Select from "react-select";
import styled from "styled-components";
import { useHistory } from "react-router";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { RootState } from "../../store/rootReducer";
import { useDispatch, useSelector } from "react-redux";
import { fieldErrorMessage, fieldHasErrors } from "../../store/errorHandler";
import { allowDelete, allowSave, getSelectedStatusOption, Option, STATUS_OPTIONS } from "../../store/helpers";
import { createBentukKerjasamaAsync, getDetailBentukKerjasamaAsync, initializeCreateBentukKerjasama, updateBentukKerjasamaAsync, updateName, updateStatus } from "../../reducers/bentukKerjasama/bentukKerjasama.actions";
import { PermissionMenuName } from "../../interfaces/UserRole";

export const BentukKerjasamaUpdatePage = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();
  const [isNew, setIsNew] = useState<boolean>(false);
  const errors = useSelector((state: RootState) => state.bentukKerjasama.error);
  const isLoading = useSelector((state: RootState) => state.bentukKerjasama.isLoading);
  const redirectQueue = useSelector((state: RootState) => state.bentukKerjasama.redirectQueue);
  const bentukKerjasama = useSelector((state: RootState) => state.bentukKerjasama.selectedBentukKerjasama);
  const role = useSelector((state: RootState) => state.authorization.systemAccess[PermissionMenuName.masterData].ACCESS);

  const canSave = allowSave(role, 2);

  useEffect(() => {
    const paths = location.pathname.split("/");
    if (paths[2] === 'create') {
      setIsNew(true);
      dispatch(initializeCreateBentukKerjasama());
    } else {
      setIsNew(false);
      const id = parseInt(paths[2]);
      if (id && !isNaN(id)) {
        dispatch(getDetailBentukKerjasamaAsync.request({ id }));
      } else {
        history.push(`/bentuk-kerjasama/create`);
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  useEffect(() => {
    if (redirectQueue) {
      history.push(redirectQueue);
      dispatch(initializeCreateBentukKerjasama());
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [redirectQueue]);

  const onChangeName = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(updateName(e.target.value));
  }

  const onChangeStatus = (e: Option | null) => {
    if (!e) return;
    if (isNaN(parseInt(e.value))) return;
    dispatch(updateStatus(parseInt(e.value)));
  }

  const save = () => {
    if (!bentukKerjasama) return;
    if (isNew) {
      dispatch(createBentukKerjasamaAsync.request(bentukKerjasama))
    } else {
      dispatch(updateBentukKerjasamaAsync.request(bentukKerjasama))
    }
  }
 
  return (
    <BentukKerjasamaUpdatePageWrapper>
      <section className="content">
        <div className="row">
          <div className="col-lg-5">
            <div className="box">
              <div className="box-header with-border">
                <h3 className="box-title">Detail Bentuk Kerjasama</h3>
                <div className="box-tools">
                  <button
                    className="btn btn-primary"
                    style={{marginRight: '4px'}}
                    onClick={() => history.push('/bentuk-kerjasama')}
                  >
                    kembali
                  </button>
                  <button
                    className="btn btn-primary"
                    disabled={isLoading || !canSave}
                    onClick={save}
                  >
                    Simpan
                  </button>
                </div>
              </div>
              <div className="box-body">
                <div className={`form-group ${fieldHasErrors('NAMA', errors) ? 'has-error' : ''}`}>
                  <label>Nama Bentuk Kerjasama <span className="text-red"><b>*</b></span></label>
                  <input
                    type="text"
                    onChange={onChangeName}
                    className='form-control'
                    disabled={isLoading || !canSave}
                    defaultValue={bentukKerjasama?.NAMA}
                    style={{ display: 'block', width: '100%' }}
                  />
                  <span className="help-block">{ fieldErrorMessage('NAMA', errors) }</span>
                </div>
                <div className="form-group">
                  <label>Status <span className="text-red"><b>*</b></span></label>
                  <Select 
                    options={STATUS_OPTIONS}
                    onChange={onChangeStatus}
                    isDisabled={isLoading || !allowDelete(role, 2)}
                    value={getSelectedStatusOption(bentukKerjasama?.STATUS)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </BentukKerjasamaUpdatePageWrapper>
  );
}

const BentukKerjasamaUpdatePageWrapper = styled.div``;